import styles from './Checkout.scss';

import React, { useState } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch
} from 'react-router-dom';

import { useCart } from 'src/components/Cart/UseCart';
import { isCartItemQuantityMax } from 'src/components/Cart/Util';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import { CheckoutBasePage } from './CheckoutBasePage/CheckoutBasePage';
import { CheckoutEmailPage } from './CheckoutEmailPage/CheckoutEmailPage';
import { CheckoutInfoPage } from './CheckoutInfoPage/CheckoutInfoPage';
import { CheckoutProvider } from './CheckoutProvider';
import { CheckoutReviewPage } from './CheckoutReviewPage/CheckoutReviewPage';
import { CheckoutStatusPage } from './CheckoutStatusPage/CheckoutStatusPage';

export enum CheckoutRoutePath {
  INFO = '/info',
  REVIEW = '/review',
  EMAIL = '/email',
  STATUS = '/status',
}

interface CheckoutProps extends RouteComponentProps<{}> {}

export const Checkout: React.FC<CheckoutProps> = ({ match }) => {
  const [contentNode, setContentNode] = useState<HTMLDivElement | null>();
  const infoPath = `${match.url}${CheckoutRoutePath.INFO}`;
  const reviewPath = `${match.url}${CheckoutRoutePath.REVIEW}`;
  const emailPath = `${match.url}${CheckoutRoutePath.EMAIL}`;
  const statusPath = `${match.url}${CheckoutRoutePath.STATUS}`;
  const { cart } = useCart();

  return (
    <section className={styles.checkoutWrapper}>
      <CheckoutProvider>
        <CheckoutBasePage offsetElement={contentNode}>
          <Switch>
            {(isCartItemQuantityMax(cart.bundle?.hardware) || isCartItemQuantityMax(cart.products)) && (
             <Redirect to={redesignV2RoutePath.CART} />
            )}
            <Route exact path={infoPath}>
              <CheckoutInfoPage ref={setContentNode} />
            </Route>
            <Route exact path={reviewPath}>
              <CheckoutReviewPage />
            </Route>
            <Route exact path={emailPath}>
              <CheckoutEmailPage />
            </Route>
            <Route exact path={statusPath}>
              <CheckoutStatusPage />
            </Route>
          </Switch>
        </CheckoutBasePage>
      </CheckoutProvider>
    </section>
  );
};

Checkout.displayName = 'Checkout';
